import { useMarketingCampaignFormModelContext } from "../../../../../../model";
import { useMarketingExistingCampaignFormModelContext } from "../../../../context";

export const useUpdateButton = () => {
	const { viewModel } = useMarketingCampaignFormModelContext();
	const { onUpdate } = useMarketingExistingCampaignFormModelContext();

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		onUpdate,
	};
};
